module.exports = __webpack_public_path__ + "img/lg_ring_g_0_null_null.884f53e2.png";